import { FormattedMessage } from 'react-intl'
import { Box, Paper, styled } from '@mui/material'
import { Button, Typography } from '@carto/meridian-ds/components'
import ProviderIcon from 'features/common/ui/ProviderIcon/ProviderIcon'
import { ProviderType } from '../types'
import { DOCS_CONNECTIONS } from 'app/constants/urls'
import ConnectionsNewButton from './ConnectionsNewButton'
import { useGovernanceConnections } from '../hooks/useGovernanceConnections'

const CONNECTION_BANNER_BACKGROUND_URL =
  'https://app-gallery.cartocdn.com/onboarding_assets/connections_banner_dark.svg'

const Banner = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(4),
  marginBottom: theme.spacing(4),
  borderRadius: theme.spacing(1),
  backgroundImage: `url('${CONNECTION_BANNER_BACKGROUND_URL}')`,
  backgroundColor: theme.palette.brand.navyBlue,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right'
}))

const Label = styled(Typography)(({ theme }) => ({
  display: 'block',
  height: theme.spacing(2),
  width: 'fit-content',
  padding: theme.spacing(0.125, 0.5),
  marginBottom: theme.spacing(0.75),
  borderRadius: theme.spacing(0.25),
  background: theme.palette.secondary.main,
  textTransform: 'uppercase'
}))

const ProvidersList = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& > *': {
    marginRight: theme.spacing(1)
  }
}))

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.brand.appBarContrastText,
  marginBottom: theme.spacing(1.75)
}))

const Content = styled(Typography)(({ theme }) => ({
  color: theme.palette.brand.appBarContrastText
}))

function NoConnectionsOrCdw() {
  const { hasAvailableProviders } = useGovernanceConnections()
  return (
    <Banner elevation={0}>
      <Label variant="caption" weight="medium" display="inline">
        <FormattedMessage id="home.noCartoDW.getStarted" />
      </Label>
      <Box maxWidth="50%">
        <Box>
          <Title variant="h4">
            <FormattedMessage id="connections.connectionsListBanner.title" />
          </Title>
          <Content variant="body1">
            <FormattedMessage id="home.onboarding.dataWarehouse.content" />
          </Content>
          <ProvidersList>
            <ProviderIcon provider={ProviderType.SNOWFLAKE} />
            <ProviderIcon provider={ProviderType.BIGQUERY} />
            <ProviderIcon provider={ProviderType.DATABRICKS} />
            <ProviderIcon provider={ProviderType.POSTGRES} />
            <ProviderIcon provider={ProviderType.REDSHIFT} />
          </ProvidersList>
        </Box>
        <Box mt={9}>
          <ConnectionsNewButton
            label={<FormattedMessage id="connections.createYourFirstConnection" />}
            disabled={!hasAvailableProviders}
            placement="top"
          />
          <Button href={DOCS_CONNECTIONS} external size="large" variant="text" color="primary">
            <FormattedMessage id="workflows.analyticsToolbox.componentTreeInfo.learnMore" />
          </Button>
        </Box>
      </Box>
    </Banner>
  )
}

export default NoConnectionsOrCdw
